import {
  MotivationScanAnswers,
  MotivationScanLike,
} from "@/utils/motivationScan";
import {
  createBackendApiClient,
  createBackendApiClientWithReq,
} from "@/server/backend-api/createBackendApiClient";
import { ServerRequest } from "../../types";
import { MotivationScanResultAnswer } from "@/server/backend-api/generated";
import { getAuthStatus } from "@/server/getAuthStatus";

export async function updateMotivationScanAnswers(
  answers: MotivationScanAnswers,
  req: ServerRequest
) {
  const client = createBackendApiClientWithReq(req);
  const mapped = mapAnswersToApiAnswers(answers);
  await client.profile_UpdateMotivationScanResult({
    answers: mapped,
  });
}

export async function getMotivationScanAnswersIfExists(
  req?: ServerRequest
): Promise<MotivationScanAnswers | null> {
  const auth = req ? getAuthStatus(req) : undefined;
  if (auth?.isAuthenticated !== true) {
    return null;
  }

  const client = createBackendApiClient(auth.token);
  const profile = await client.profile_Get();
  const motivationScanResult = profile.motivationScanResult;
  if (motivationScanResult === null) {
    return null;
  }
  return mapApiAnswersToAnswers(motivationScanResult.answers);
}

function mapAnswersToApiAnswers(
  answers: MotivationScanAnswers
): MotivationScanResultAnswer[] {
  const keys = Object.keys(answers);
  return keys.map((key) => {
    const result: MotivationScanResultAnswer = {
      competenceId: key,
      like: answers[key]?.likeOrDislike === MotivationScanLike.Like,
    };
    return result;
  });
}

function mapApiAnswersToAnswers(
  answers: MotivationScanResultAnswer[]
): MotivationScanAnswers {
  const result: MotivationScanAnswers = {};
  for (const answer of answers) {
    result[answer.competenceId] = {
      competenceId: answer.competenceId,
      likeOrDislike: answer.like
        ? MotivationScanLike.Like
        : MotivationScanLike.Dislike,
    };
  }
  return result;
}
